import '../../App.css';
import '../../Css/Description.css';
import '../../Css/Team.css'

export default function TJDescription(props) {

  return (
      <div>
          <div className='tj-container section-border-top'>
            <div className='tj-title-container'>
              
              <div className='title'>
                <div className='section-title'>Responsables Bien-être</div>
                <div className='HLContainer'><div className='big-line'></div></div>
              </div>
             
            </div>
           
          <div className='tj-description'>
            <div className='tj-images-flex'>
              <img className='tj-image section-border-bottom' src='./images/photos/Johnny_2.jpg'></img>
              <img className='tj-image section-border-bottom' src='./images/photos/Tala_2.jpg'></img>
              
            </div>
            
             
            <div className='tj-text-container text'>
                <p>Toujours de bonne humeur, nos Responsables bien-être se chargent de garder Adeline et Miranda au meilleur de leur forme. Ainsi, nous vous garantissons des interlocutrices motivées et à votre écoute.</p>
                <p>Avec sa vision 100% positive du monde, Tala, cavalier king charles, instaure un souffle de positivité et d'espoir dans toutes les situations.</p>
                <p>Johnny, chinchilla aventureux, sait transmettre sa détermination à toute l'équipe pour qu'aucun défi ne lui résiste.</p>
                <p> Ensemble, Tala et Johnny veillent au grain pour que derrière chaque besoin technique ou stratégique, il y ait toujours une équipe sereine, motivée et pleinement disponible.</p>
            </div>
            
            
          </div>
        </div>
      </div>
    );
  }